import * as types from '../action/actionTypes';
import initialState from './initialState';

export default function WorkorderReducer(state = initialState.Workorder, action){
    switch(action.type){
        case types.GET_WORKORDER_SCHEDULE: 
        return{
            ...state,Workorderlist: action.getResponse,
        };
        case types.GET_WORKORDERLIST:
        return{
            ...state,WorkOrderList: action.getResponse,
        }
        case types.GET_CLOSEDWORKORDERLIST:
        return{
            ...state,ClosedWorkOrderList: action.getResponse,
        }
        case types.GET_WORKORDERDETAILS:
        return{
            ...state,WorkOrderDetails: action.getResponse,
        }
        case types.GET_WORKORDER_BUILDINGS:
        return{
            ...state,WorkorderBuildings: action.getResponse,
        }
        case types.GET_WORKORDER_EQUIPMENTS:
        return{
            ...state,WorkorderEquipments: action.getResponse,
        }
        case types.GET_WORKORDER_BUILDING:
        return{
            ...state,WorkorderBuildingDetails: action.getResponse,
        }
        case types.GET_WORKORDER_BUILDINGS_EQUIPMENTS:
        return{
            ...state,BuildingsEquipments: action.getResponse,
        }
        case types.GET_PM_BUILDINGS_EQUIPMENTS:
        return{
            ...state,PMBuildingsEquipments: action.getResponse,
        }

        case types.GET_TECHNICIANLIST:
        return{
            ...state,Technicians: action.getResponse,
        }
        case types.GET_TECHNICIANDETAILS:
        return{
            ...state,TechnicianDetails: action.getResponse,
        }
        case types.CHANGE_VIEW_WORKORDER_BUILDINGS:
        return{
            ...state,WorkOrderBuildingDisplay: { page_to_display_building: action.page_to_display_building, Selected_Building_Id: action.Selected_Building_Id }
        }
        case types.CHANGE_VIEW_WORKORDER_TENANTS:
        return{
            ...state,WorkOrderTenantDisplay: { page_to_display_tenant: action.page_to_display_tenant }
        }
        case types.GET_STANDARD_FIELDS:
        return{
            ...state,WorkOrderStandardFields: action.getResponse
        }
        case types.GET_CUSTOM_FIELDS:
        return{
            ...state,WorkOrderCustomFields: action.getResponse
        }
        case types.GET_PM_TEMPLATES:
        return{
                ...state,PreventativeMaintenanceTemplates: action.getResponse
        } 
        case types.TENANT_TO_ASSOCIATE:
        return{
            ...state,TenantToAssociate: { tenant_to_associate: action.tenant_to_associate }
        }
        case types.GET_TENANT_ASSOCIATION:
        return{
            ...state,TenantAssociations: action.getResponse,
        }
        case types.GET_PREVENTATIVEMAINTENCELIST:
        return{
            ...state,PreventativeMaintenanceList: action.getResponse,
        }
        case types.GET_CLOSEDPREVENTATIVEMAINTENANCELIST:
        return{
            ...state,ClosedPreventativeMaintenaceList: action.getResponse,
        }
        case types.GET_PREVENTATIVE_MAINTENANCE_STANDARD_FIELDS:
        return{
            ...state,PreventativeMaintenanceStandardFields: action.getResponse
        }
        case types.GET_PREVENTATIVEMAINTENANCEDETAIL:
        return{
            ...state,PreventativeMaintenanceDetail: action.getResponse,
        }
        case types.GET_PM_FAMILYTYPES:
        return{
            ...state,BuildingFamilyTypes: action.getResponse,
        }
        case types.GET_PM_USAGE_FAMILYTYPES:
        return{
            ...state,UsageBuildingFamilyTypes: action.getResponse,
        }
        case types.GET_PM_EQUIPMENTS_BY_FAMILYTYPE:
        return{
            ...state,BuildingEquipmentsByFamilyType: action.getResponse,
        }
        case types.GET_PM_USAGE_EQUIPMENTS_BY_FAMILYTYPE:
        return{
            ...state,UsageBuildingEquipmentsByFamilyType: action.getResponse,
        }
        case types.GET_PM_SERVERTIME:
        return{
            ...state,ServerTime: action.getResponse,
        }
        case types.GET_PM_BUILDING_EQUIPMENT_POINTS:
        return{
            ...state,BuildingEquipmentPoints: action.getResponse,
        }
        case types.GET_PM_BUILDING_POINTS:
        return{
            ...state,BuildingPoints: action.getResponse,
        }
        case types.GET_PM_DISCOVERED_BUILDINGS:
        return{
            ...state,DiscoverdBuildings: action.getResponse,
        }
        case types.GET_MAILSETTING:
        return{
            ...state,MailSetting: action.getResponse,
        }
        case types.ADD_CUSTOM_CLOSE_MODAL_POPUP:
            return{
                ...state, AddCutomModalOpenClose: { modal_open: action.add_custom_modal_open , CustomFieldId : action.CustomFieldId }
            }
        case types.ADD_TEMPLATE_CLOSE_MODAL_POPUP:
            return{
                ...state, AddTemplateModalOpenClose: { modal_open: action.add_template_modal_open , templateId : action.templateId }
            }
        case types.GET_PM_CUSTOM_FIELDS:
            return{
                ...state, PreventativeMaintenanceCustomFields: action.getResponse,
            }
        case types.GET_ALL_WORKORDERREPORTSLIST:
            return{
                ...state, WorkorderReportsList: action.getResponse,
            }    
        case types.GET_WORKORDERREPORTS_DETAILS:
            return{
                ...state, WorkorderReportsDetails: action.getResponse,
            }
        case types.GET_UNIQUEFILENAME:
            return{
                ...state, UniqueAttachmentName: action.getResponse
            }
        case types.GET_UNIQUEFILECOLLECTION:
            return{
                ...state, UniqueAttachmentCollection: action.getResponse
            }
        case types.GET_PM_TEMPLATE_DETAILS:
            return{
                ...state, PreventativeMaintenanceTemplateDetails: action.getResponse
            }
        case types.GET_WOSETUPMAILADDRESSES:
            return{
                ...state, WorkOrderSetupMailAddresses: action.getResponse
            }
        case types.GET_PMSETUPMAILADDRESSES:
            return{
                ...state, PreventativeMaintenanceSetupMailAddresses: action.getResponse
            }
        case types.GET_SERVICE_REQUEST_SETUP_DETAILS:
            return{
                ...state, ServiceRequestSetUpDetails: action.getResponse
            }
        case types.GET_WOFORM_CUSTOMFIELDS:
            return{
                ...state, WorkOrderFormCustomFields: action.getResponse
            }
        case types.GET_WOFORM_TENANTLISTS:
            return{
                ...state, WorkOrderFormTenantLists: action.getResponse
            }
        default : return state;
    }
}